import { Locale } from 'App/i18n/enums';

/**
 * Default language for fallbacks in help links and translations
 */
export const DEFAULT_LANGUAGE = Locale.ARGENTINA;
